import { Alert, Link, Typography } from "@mui/joy";
import { memo } from "react";

const NonSupportedMediaDataRoomAlert = memo(() => (
  <Alert color="danger" sx={{ m: 2 }}>
    <div>
      <div>This Media DCR version is not supported anymore</div>
      <div>
        Please contact{" "}
        <Typography display="inline" level="body-sm">
          <Link
            color="neutral"
            href="mailto:support@decentriq.com"
            tabIndex={0}
            underline="always"
          >
            support@decentriq.com
          </Link>
        </Typography>{" "}
        if you still need access to it.
      </div>
    </div>
  </Alert>
));
NonSupportedMediaDataRoomAlert.displayName = "NonSupportedMediaDataRoomAlert";

export default NonSupportedMediaDataRoomAlert;
